// extracted by mini-css-extract-plugin
export default {"baseMarker":"Marker_baseMarker__XqmgB","focused":"Marker_focused__km45Z","light":"Marker_light__UKyDZ","dark":"Marker_dark__0cEw8"};